'use client';

import { useEffect, useState } from 'react';

export function useIntercomUnread(): boolean {
  const [hasUnread, setHasUnread] = useState(false);

  useEffect(() => {
    const handler = (count: number) => {
      setHasUnread(count > 0);
    };

    if (typeof window !== 'undefined' && window.Intercom) {
      window.Intercom('onUnreadCountChange', handler);
    }

    return () => {
      if (typeof window !== 'undefined' && window.Intercom) {
        window.Intercom('onUnreadCountChange', () => {});
      }
    };
  }, []);

  return hasUnread;
}
